import React from 'react';
import { Search } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Input } from '../ui/input';

const EmployeesSearchCard = ({ t, searchTerm, setSearchTerm, selectedDepartement }) => (
  <Card>
    <CardHeader>
      <CardTitle>{t('employeesPage.sections.search')}</CardTitle>
      <CardDescription>
        {t('employeesPage.descriptions.searchEmployee')}
        {selectedDepartement && (
          <span className="text-primary"> • Filtré par département: {selectedDepartement.name}</span>
        )}
      </CardDescription>
    </CardHeader>
    <CardContent>
      <div className="relative">
        <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder={t('employeesPage.placeholders.searchEmployee')}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-9"
        />
      </div>
    </CardContent>
  </Card>
);

export default EmployeesSearchCard;
